<template>
    <div class="profile-inputs">
        <modal ref="changePasswordModal" class="text-left">
            <form @submit.prevent="changePassword">

                <label>Nuvarande lösenord</label>
                <input
                    type="password"
                    class="form-control mt-0"
                    v-model="changePasswordForm.current_password"
                    :class="{ 'is-invalid': changePasswordForm.errors.has('current_password') }"
                />

                <div v-if="changePasswordForm.errors.has('current_password')" class="invalid-feedback d-block text-left">
                    {{ changePasswordForm.getError('current_password') }}
                </div>

                <label class="mt-4">Nytt lösenord</label>
                <input
                    type="password"
                    class="form-control mt-0"
                    v-model="changePasswordForm.password"
                    :class="{ 'is-invalid': changePasswordForm.errors.has('password') }"
                />

                <div v-if="changePasswordForm.errors.has('password')" class="invalid-feedback d-block text-left">
                    {{ changePasswordForm.getError('password') }}
                </div>

                <label class="mt-4">Nytt lösenord igen</label>
                <input
                    type="password"
                    class="form-control mt-0"
                    v-model="changePasswordForm.password_confirmation"
                    :class="{ 'is-invalid': changePasswordForm.errors.has('password_confirmation') }"
                />

                <div v-if="changePasswordForm.errors.has('password_confirmation')" class="invalid-feedback d-block text-left">
                    {{ changePasswordForm.getError('password_confirmation') }}
                </div>

                <button type="button" class="btn btn-danger mt-4" v-if="changePasswordForm.processing">Laddar...</button>
                <button type="submit" class="btn btn-danger mt-4" v-else>Byt lösenord</button>
            </form>
        </modal>

        <h4 class="subtitle">{{ $t('your_profile') }}</h4>
        <form @submit.prevent="updateUser">
            <input type="text" class="form-control" :placeholder="$t('first_name')" v-model="form.first_name"  :class="{ 'is-invalid': form.errors.first_name }"/>
            <div v-if="form.errors.first_name" class="invalid-feedback d-block text-left">
                {{ form.errors.first_name }}
            </div>

            <input type="text" class="form-control" :placeholder="$t('last_name')" v-model="form.last_name"  :class="{ 'is-invalid': form.errors.last_name }"/>
            <div v-if="form.errors.last_name" class="invalid-feedback d-block text-left">
                {{ form.errors.last_name }}
            </div>

            <input type="text" class="form-control" :placeholder="$t('email')" v-model="form.email"  :class="{ 'is-invalid': form.errors.email }"/>
            <div v-if="form.errors.email" class="invalid-feedback d-block text-left">
                {{ form.errors.email }}
            </div>

            <input type="text" class="form-control" placeholder="Födelsedatum ÅÅÅÅ-MM-DD" v-model="form.contact.dob" />
            <div v-if="form.errors['contact.dob']" class="invalid-feedback d-block text-left">
                {{ form.errors['contact.dob'] }}
            </div>

           <div class="city-wrapper">
                <div class="bg-white">
                    <multiselect
                        placeholder="* Stad"
                        v-model="form.city_id"
                        value-prop="id"
                        track-by="name"
                        label="name"
                        name="city_id"
                        :searchable="true"
                        :options="$page.props.cities" />
                </div>
                <div v-if="form.errors.city_id" class="invalid-feedback d-block text-left">
                    {{ form.errors.city_id }}
                </div>
            </div>

            <input type="text" class="form-control" :placeholder="$t('telephone')" v-model="form.contact.phone" />
            <div v-if="form.errors['contact.phone']" class="invalid-feedback d-block text-left">
                {{ form.errors['contact.phone'] }}
            </div>

            <select class="form-control" @change="showInputs" v-model="numberOfChildren">
                <option value="0">{{ $t('number_of_children') }}</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
            </select>
            <div id="age-of-children">
                <div class="form-group" v-if="numberOfChildren > 0">
                    <div v-for="(child, i) in numberOfChildren" :key="child.id" style="text-align: left; margin-top: 15px;">
                        <label :for="'child-' + i" >Födelseår barn {{swedishNumbers[i]}}:</label>
                        <div style="display:flex; justify-content:center; align-items:center;">
                            <select class="form-control select-ages" v-model="form.children[i]" style="margin-top: 0px;">
                                <option value="">ÅÅÅÅ</option>
                                <option v-for="(n,index) in 18" :key="index" :value="currentYear - index"> {{currentYear - index}} </option>
                            </select>
                            <a href="javascript:void(0)" v-on:click="removeChildren(i)" class="ml-2"><i class="fas fa-times"></i></a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-check text-left mt-2">
                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" v-model="form.newsletter_consent">
                <label class="form-check-label" for="flexCheckDefault">
                    Ja, tack. Jag vill prenumerera på pangrabatter och superdeals från Familjekortet.
                </label>
            </div>

            <button type="button" class="btn save-button" v-if="form.processing">Sparar...</button>
            <button type="submit" class="btn save-button" v-else>{{ $t('save') }}</button>

            <div class="flex">
                <p class="logout mt-2 text-right cursor-pointer" @click="showChangePasswordModal"><u>Byt lösenord</u></p>
                <p class="logout mt-2 text-right cursor-pointer ml-auto" @click="logout"><u>{{ $t('logout') }}</u></p>
            </div>
        </form>
    </div>
</template>

<script>
import Form from 'form-backend-validation';
import AuthService from '@/services/auth.service';

export default {
    props: ['user'],

    data () {
        return {
            form: this.$inertia.form({
                first_name: null,
                last_name: null,
                email: null,
                city_id: null,
                children: [],
                newsletter_consent: false,
                contact: {
                    phone: null,
                    dob: null,
                }
            }),
            changePasswordForm: new Form({
                current_password: null,
                password: null,
                password_confirmation: null,
            }),
            numberOfChildren: 0,
            swedishNumbers: ['ett', 'två', 'tre', 'fyra', 'fem', 'sex', 'sju', 'åtta', 'nio', 'tio', 'elva', 'tolv', 'tretton'],
            currentYear: ""
        }
    },

    created () {
        var d = new Date();
        this.currentYear = d.getFullYear();

        this.form.city_id = this.user.city_id;
        this.form.first_name = this.user.first_name;
        this.form.last_name = this.user.last_name;
        this.form.email = this.user.email;
        this.form.newsletter_consent = this.user.newsletter_consent;

        this.form.children = this.user.children.map((c) => c.year_of_birth);
        this.numberOfChildren = this.user.children.length;

        this.form.contact.phone = this.user.contact.phone;
        this.form.contact.dob = this.user.contact.dob;
    },

    computed: {
        cities() {
            return this.$store.state.cities;
        },
    },

    methods: {
        getUser () {
            axios.get('api/auth/user').then(response => {
                this.user = response.data.data;
            });
        },

        showChangePasswordModal () {
            this.$refs.changePasswordModal.show();
        },

        changePassword () {
            if (this.changePasswordForm.processing) {
                return;
            }

            this.changePasswordForm.processing = true;

            setTimeout(() => {
                this.changePasswordForm.post(`/api/auth/change-password`).then(response => {
                    this.$refs.changePasswordModal.close();

                    this.$moshaToast('Ditt lösenord har blivit uppdaterat!', {
                        type: 'success',
                        timeout: 2000,
                    });
                }).catch(error => {});
            }, 300);
        },

        removeChildren (index) {
            this.form.children.splice(index, 1);
            this.numberOfChildren = this.numberOfChildren - 1;
        },

        showInputs () {
            this.numberOfChildren = parseInt(this.numberOfChildren);
        },

        updateUser () {
            if (this.form.processing) {
                return;
            }

            this.form.processing = true;

            var ages = $.map($('.select-ages'), function (el) { return el.value; });
            this.form.children = ages;

            setTimeout(() => {
                this.form.put(`/api/auth/user`, {
                    onSuccess: () => this.$emit('updated')
                });
            }, 300);
        },

        logout () {
            AuthService.logout();
        }
    }
}
</script>
